import { isCoordinateLocation } from '../realtime/contracts';
import type { LocationSource, PortalCoordinateLocation, PortalLocation } from '../realtime/contracts';

export type IncidentLocationMapProjection = {
  selectedSource: LocationSource | null;
  selectedCurrentLocation: PortalCoordinateLocation | null;
  selectedTrack: PortalCoordinateLocation[];
  contextualLastLocations: PortalCoordinateLocation[];
};

export function projectIncidentLocationsForMap(
  currentLocation: PortalLocation | null,
  selectedTrack: readonly PortalLocation[],
  lastLocationsBySource: readonly PortalLocation[],
): IncidentLocationMapProjection {
  const selectedSource = currentLocation?.source ?? selectedTrack.at(-1)?.source ?? null;

  return {
    selectedSource,
    selectedCurrentLocation: currentLocation !== null && isCoordinateLocation(currentLocation) ? currentLocation : null,
    selectedTrack: selectedTrack.filter(isCoordinateLocation),
    contextualLastLocations: lastLocationsBySource.filter(
      (location): location is PortalCoordinateLocation =>
        location.source !== selectedSource && isCoordinateLocation(location),
    ),
  };
}
